<template>
  <div class="project_box">
    <div class="flexout top1">
      <span class="line"></span><span class="text">设备预警</span>
    </div>
    <div class="flexout top2" style="margin-bottom: 15px">
      <el-date-picker
        style="width: 145px; margin-right: 5px"
        v-model="date"
        type="date"
        placeholder="选择日期"
        @change="search"
      >
      </el-date-picker>
      <el-input
        placeholder="请输入设备名称进行搜索"
        v-model="content"
        @keyup.enter.native="search"
      ></el-input>
    </div>
    <div class="content">
      <div class="task_tab tab_box contentTab">
        <div
          :class="[taskTabIndex == '0' ? 'task_tabActive' : 'task_tabOne']"
          @click="changeTaskTab(0)"
        >
          全部
        </div>
        <!-- <div :class="[taskTabIndex=='1'?'task_tabActive':'task_tabOne']" style="margin-left:24px;" @click="changeTaskTab(1)">离线</div> -->
        <!-- <div :class="[taskTabIndex=='2'?'task_tabActive':'task_tabOne']" style="margin-left:24px;" @click="changeTaskTab(2)">故障</div> -->
      </div>
      <div class="contentchildlist">
        <div v-if="showData.length == 0" class="space">暂无数据</div>
        <div
          class="tab_box textStart martop15"
          v-for="(item, index) in showData"
          :key="index"
          v-else
        >
          <div class="icon3">离线</div>
          <el-tooltip placement="top">
            <div slot="content">
              {{ item.dataTime }}
            </div>

            <div class="colorText marginr15">{{ item.dataTime }}</div>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content">
              {{ item.content }}
            </div>

            <div class="colorText">{{ item.content }}</div>
          </el-tooltip>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getMsgList } from "../../../../../../request/msgApi";
import { getChildGrop, getZiDian } from "../../../../../../request/api";
export default {
  data() {
    return {
      date: new Date(),
      taskTabIndex: 0,
      tabPosition: "left",
      activeInd: "0",
      showData: [],
      allData: [],
      offData: [],
      breakData: [],
      sourceName: "",
      content: "",
    };
  },
  created() {
    this.search();
    // this.postGrop();
    // this.getType(
    //   {
    //     page: 1,
    //     size: 10000,
    //     messageType: "early_warning",
    //     // "category":"",
    //     type: "device_warning",
    //     // "sourceName":"",
    //     // "dataTime":this.date
    //   },
    //   "all"
    // );
    // let that = this;
    // this.timer = setInterval(function () {
    //   that.getType(
    //     {
    //       page: 1,
    //       size: 10000,
    //       messageType: "early_warning",
    //       // "category":"",
    //       type: "device_warning",
    //       // "sourceName":"",
    //       // "dataTime":this.date
    //     },
    //     "all"
    //   );
    // }, 180000);
  },
  methods: {
    postGrop() {
      let that = this;
      let params = {
        page: 1,
        size: 999,
        parent: "message_type", //父组code
      };
      getChildGrop(params).then((res) => {
        console.log("gropCode");
        console.log(res);
      });
    },
    getType(params, type) {
      let that = this;
      getMsgList(params).then((res) => {
        console.log("xiaoxi");
        console.log(res);
        if (res.code == 0) {
          if (type == "all") {
            that.allData = res.data;
          } else if (type == "off") {
            that.offData = res.data;
          } else if (type == "break") {
            that.breakData = res.data;
          }
          that.showData = res.data;
        }
      });
    },
    changeTaskTab(index) {
      this.taskTabIndex = index;
      if (index == 0) {
        if (this.allData.length == 0) {
          this.getType(
            {
              page: 1,
              size: 10000,
              messageType: "early_warning",
              // "category":"",
              type: "device_warning",
              sourceName: this.sourceName,
              dataTime: this.date,
            },
            "all"
          );
        } else {
          this.showData = this.allData;
        }
      } else if (index == 1) {
        if (this.offData.length == 0) {
          this.getType(
            {
              page: 1,
              size: 10000,
              messageType: "early_warning",
              category: "offline",
              type: "device_warning",
              sourceName: this.sourceName,
              dataTime: this.date,
            },
            "off"
          );
        } else {
          this.showData = this.offData;
        }
      } else if (index == 2) {
        if (this.breakData.length == 0) {
          this.getType(
            {
              page: 1,
              size: 10000,
              messageType: "early_warning",
              category: "breakdown",
              type: "device_warning",
              sourceName: this.sourceName,
              dataTime: this.date,
            },
            "break"
          );
        } else {
          this.showData = this.breakData;
        }
      }
    },
    search() {
      let index = this.taskTabIndex;
      if (index == 0) {
        this.getType(
          {
            page: 1,
            size: 10000,
            messageType: "early_warning",
            // "category":"",
            type: "device_warning",
            content: this.content,
            dataTime: this.date ? this.date.format("yyyy-MM-dd") : null,
          },
          "all"
        );
      } else if (index == 1) {
        this.getType(
          {
            page: 1,
            size: 10000,
            messageType: "early_warning",
            category: "offline",
            type: "device_warning",
            sourceName: this.sourceName,
            dataTime: this.date,
          },
          "off"
        );
      } else if (index == 2) {
        this.getType(
          {
            page: 1,
            size: 10000,
            messageType: "early_warning",
            category: "breakdown",
            type: "device_warning",
            sourceName: this.sourceName,
            dataTime: this.date,
          },
          "break"
        );
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.flexout {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 10px;
  .line {
    display: inline-block;
    width: 4px;
    height: 22px;
    background: #00c6ff;
    margin-right: 10px;
  }
  .text {
    font-size: 18px;
    line-height: 26px;
    color: #23c3ff;
  }
}
.tab_box {
  display: flex;
  align-items: center;
}
.betw {
  justify-content: space-between;
}
.textStart {
  justify-content: flex-start;
}
.topOne {
  width: 41.6%;
  height: auto;
  line-height: 50px;
  font-size: 0.2rem;
  text-align: right;
  padding-right: 2.6rem;
  box-sizing: border-box;
  cursor: pointer;
}
.task_tabActive {
  font-weight: bold;
  font-size: 1.4rem;
  line-height: 24px;
  letter-spacing: 0px;
  color: #23c3ff;
  border-bottom: 2px solid #00c6ff;
  cursor: pointer;
}
.task_tabOne {
  font-weight: bold;
  font-size: 1.4rem;
  line-height: 24px;
  letter-spacing: 0px;
  color: #e4f7ff;
  opacity: 0.5;
  cursor: pointer;
}
.icon1 {
  width: 38px;
  height: 24px;
  border: solid 1px #2bc2ff;
  text-align: center;
  line-height: 24px;
  margin-right: 10px;
}
.marginr15 {
  margin-right: 15px;
}
.icon2 {
  border: solid 1px #ffdc4e;
  color: #ffdc4e;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.icon3 {
  border: solid 1px #ff4e4e;
  color: #ff4e4e;
  margin-right: 5px;
  // overflow: hidden;
  // text-overflow: ellipsis;
  white-space: nowrap;
  width: 5rem;
  text-align: center;
}
.colorText {
  font-weight: bold;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 0px;
  color: #2ac1ff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 20rem;
}
.martop15 {
  margin-top: 15px;
}
.project_box {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}
.top1 {
  height: 22px;
}
.top2 {
  height: 55px;
}
.content {
  flex: 1;
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}
.contentTab {
  width: 100%;
  height: 30px;
}
.contentchildlist {
  flex: 1;
  overflow: auto;
}
.space {
  width: 100%;
  text-align: center;
  font-size: 14px;
  color: #fff;
  opacity: 0.8;
}
</style>